import { MdAttachFile, MdOutlineFileDownload } from "react-icons/md";

const Item = ({ name, size, onDownload }) => {
  return (
    <div className="mobilityMutual__documents">
      <MdAttachFile className="mobilityMutual__documents--icon" size={24} />
      <div className="mobilityMutual__documents--content">
        <div className="mobilityMutual__documents--content--name">{name}</div>
        <div className="mobilityMutual__documents--content--size">{size}</div>
      </div>
      <div className="mobilityMutual__documents--action" onClick={onDownload}>
        <MdOutlineFileDownload size={20} />
        <span>Télécharger</span>
      </div>
    </div>
  );
};
export default Item;
